import { Button, ButtonButtonElementProps } from "@teamscheme/button";
import styled from "styled-components";

export const NafCheckoutButton = styled(function (
  props: Omit<ButtonButtonElementProps, "children" | "variant" | "block">
) {
  return (
    <Button {...props} block variant="secondary">
      Gå til betaling
    </Button>
  );
})`
  margin-bottom: 0.75em;
`;
